import { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faMagnifyingGlass, faXmark } from '@fortawesome/free-solid-svg-icons';
import BarcodeCameraButton, { isBarcodeCameraSupported } from '../Scanner/BarcodeCameraButton';
import './PublicCatalog.scss';

// A barcode typed in the search field (EAN-8 … GTIN-14) is searched as a barcode
const BARCODE_RE = /^\d{8,14}$/;
const POPULAR_SEARCHES = ['Doliprane', 'Paracétamol', 'Amoxicilline', 'Ibuprofène', 'Vitamine C'];

// The directory's search card: tinted rounded panel with a search badge, title, one field
// (name, DCI or barcode) with a "Rechercher" button, popular searches and a link to the whole
// directory — submitting goes to /{lang}/medicaments with the query. Under a public product
// page ("Rechercher un autre produit") and on the landing page; the texts default to the
// product page's French ones, the landing passes its translated ones.
const ProductSearchCard = ({
    lang,
    title = 'Rechercher un autre produit',
    subtitle = 'Prix public, composition et équivalents de plus de 5 000 produits commercialisés au Maroc.',
    placeholder = 'Nom du produit, DCI ou code-barres…',
    submitLabel = 'Rechercher',
    scanLabel = 'Scanner un code-barres',
    popularLabel = 'Recherches fréquentes :',
    browseLabel = "Parcourir tout l'annuaire",
    id,
}) => {
    const navigate = useNavigate();
    const [query, setQuery] = useState('');
    const go = (value) => {
        const q = value.trim();
        if (!q) { navigate(`/${lang}/medicaments`); return; }
        navigate(`/${lang}/medicaments?${BARCODE_RE.test(q) ? 'barcode' : 'q'}=${encodeURIComponent(q)}`);
    };
    return (
        <section className="pc-search-again" id={id}>
            <span className="pc-search-again__badge"><FontAwesomeIcon icon={faMagnifyingGlass} /></span>
            <h2>{title}</h2>
            <p>{subtitle}</p>
            <form className="pc-dir__search pc-search-again__field" role="search" onSubmit={(e) => { e.preventDefault(); go(query); }}>
                <FontAwesomeIcon icon={faMagnifyingGlass} className="pc-dir__search-icon" />
                <input
                    type="search"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    placeholder={placeholder}
                    aria-label={placeholder}
                    autoComplete="off"
                />
                {query && (
                    <button type="button" className="pc-dir__search-clear" onClick={() => setQuery('')} aria-label="Effacer">
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                )}
                {isBarcodeCameraSupported() && (
                    <BarcodeCameraButton label={scanLabel} onDetected={(code) => go(code)} />
                )}
                <button type="submit" className="pc-search-again__submit">{submitLabel}</button>
            </form>
            <div className="pc-search-again__popular">
                <span>{popularLabel}</span>
                {POPULAR_SEARCHES.map(term => (
                    <button key={term} type="button" className="pc-search-again__tag" onClick={() => go(term)}>{term}</button>
                ))}
            </div>
            <NavLink to={`/${lang}/medicaments`} className="pc-search-again__browse">
                {browseLabel} <FontAwesomeIcon icon={faArrowRight} />
            </NavLink>
        </section>
    );
};

export default ProductSearchCard;
